import useModal from '@fipnooone/react-modal';
import React, { useCallback } from 'react';

import { Code, functions } from '@.api';
import { Responses } from '@.api/methods';
import { ModalConfirm } from '@.modal';
import { ConsoleDev } from '@/Lib/ConsoleDev';

interface UseModalTableConfirmParameters {
    message: string;
    confirm: (id: number) => functions;
    onError?: (responseError: Responses<unknown>) => void;
}

export const useModalTableConfirm = (parameters: UseModalTableConfirmParameters) => {
    const [modal, modalControls] = useModal();

    const action = useCallback(
        (id: number) => {
            const tableActionPromise = new Promise((resolve, reject) => {
                modalControls.set(
                    <ModalConfirm
                        message={parameters.message}
                        onCancel={() => modalControls.close()}
                        onConfirm={async () => {
                            try {
                                const response = await parameters.confirm(id);

                                if (response.code === Code.Success) {
                                    resolve(response);
                                } else {
                                    reject(response);

                                    if (parameters.onError) {
                                        parameters.onError(response);
                                    }
                                }
                            } catch (error) {
                                ConsoleDev.error(error);

                                reject(error);
                            }

                            modalControls.close();
                        }}
                    />
                );
            });

            return tableActionPromise;
        },
        [modalControls, parameters]
    );

    return {
        modal,
        action,
    };
};
